import elementUILocale from 'element-ui/lib/locale/lang/en'
import en from './en.json'

export default {
  ...elementUILocale,
  ...en
}



// WEBPACK FOOTER //
// ./src/langs/en.js